import { render, staticRenderFns } from "./Inner.vue?vue&type=template&id=67297ac4&scoped=true&"
import script from "./Inner.vue?vue&type=script&lang=js&"
export * from "./Inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67297ac4",
  null
  
)

export default component.exports